import {Head, useForm} from "@inertiajs/react";
import PrimaryButton from "@/Components/PrimaryButton";
import Layout from "@/Pages/Api/ApiPageLayout";
import React, {FormEventHandler} from "react";
import InputLabel from "@/Components/InputLabel";
import TextInput from "@/Components/TextInput";
import InputError from "@/Components/InputError";


export default function ({}) {
    const {data, setData, post, errors, processing, recentlySuccessful} = useForm({
        name: '',
        expires_at: '',
    });

    const submit: FormEventHandler = (e) => {
        e.preventDefault();
        post(route('api-keys.store'));
    };

    return (
        <>
            <Head title="Subtitle Extraction API">
                <meta name="description" content="Create an API key to access the Subtitle Extraction API."/>
            </Head>
            <Layout>
                <div className="flex justify-between items-center mx-6 mt-8">
                    <h2 className="text-xl text-gray-900 dark:text-gray-100">Create API Key</h2>
                </div>
                <div className="mt-6 mx-6 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-sm">
                    <form onSubmit={submit} className="p-10 space-y-6 max-w-[40rem]">
                        <div>
                            <InputLabel htmlFor="name" value="Name"/>

                            <TextInput
                                id="name"
                                className="mt-1 block w-full"
                                value={data.name}
                                onChange={(e) => setData('name', e.target.value)}
                                required
                                isFocused
                                autoComplete="name"
                            />

                            <InputError className="mt-2" message={errors.name}/>
                        </div>

                        <div>
                            <InputLabel htmlFor="expires_at" value="Expires At"/>

                            <TextInput
                                id="expires_at"
                                type="date"
                                className="mt-1 block w-full"
                                value={data.expires_at}
                                onChange={(e) => setData('expires_at', e.target.value)}
                            />

                            <InputError className="mt-2" message={errors.expires_at}/>
                        </div>


                        <div className="flex items-center gap-4">
                            <PrimaryButton  disabled={processing}>Submit</PrimaryButton>
                        </div>
                    </form>
                </div>

            </Layout>
        </>
    )
}
